module.exports = __webpack_public_path__ + "img/directions_car.4061c734.svg";